import * as React from 'react';
import { Component, inject, deps, observer } from '../lib/component';
import { LoadingOverlay } from '../components/loading/overlay';
import { DiscoverPage } from './discover';
import { classes, style } from 'typestyle';
import { important, percent } from 'csx';
import {PageHeader} from '../components/page-header';
import {TextNoOrphan} from '../components/text-no-orphan';
import {PageAbout} from '../components/page-about';
import {constantGoldenRatio} from '../theme/constant';
import {PageHomeCTASeparator} from '../components/page-home-cta-separator';
import {ButtonPill} from '../components/button-pill';
import {ResponsiveImageTile} from '../components/responsive-image-tile';
import MainWrapper from '../components/main-wrapper';

export interface AboutPageProps {}

@inject(deps) @observer
export class YouTubePage extends Component<AboutPageProps> {
  render() {
    const model = this.props.model.page.youtube;
    const {preloadImage} = this.props.controller.image;

    const onSignUp = this.props.model.user.user
      ? null
      : this.handleSignUp;

    return (
      <MainWrapper>
        <LoadingOverlay loading={model.loading}/>
        {!model.loading && (
          <PageHeader coverImage={model.cover_image}>
            <h1>
              <TextNoOrphan value={model.page_title} />
            </h1>
            <p>
              <TextNoOrphan value={model.page_subtitle} />
            </p>
          </PageHeader>
        )}
        {!model.loading && (
          <div className={PageAbout.styles.content}>
            <div className={PageAbout.styles.sections}>
              <div className={PageAbout.styles.section}>
                <div>
                  <h2><TextNoOrphan value={model.section_1_title}/></h2>
                  <p>{model.section_1_content}</p>
                </div>
                <div>
                  <ResponsiveImageTile
                    className={PageAbout.styles.sectionImage}
                    identity={model.section_1_image}
                    preload={preloadImage}
                    ratio={constantGoldenRatio}
                  />                </div>
              </div>
              <div className={PageAbout.styles.section}>
                <div>
                  <ResponsiveImageTile
                    className={PageAbout.styles.sectionImage}
                    identity={model.section_2_image}
                    preload={preloadImage}
                    ratio={constantGoldenRatio}
                  />
                </div>
                <div>
                  <h3><TextNoOrphan value={model.section_2_title}/></h3>
                  <p>{model.section_2_content}</p>
                </div>
              </div>
              <div className={PageAbout.styles.section}>
                <div>
                  <h3><TextNoOrphan value={model.section_3_title}/></h3>
                  <p>{model.section_3_content}</p>
                </div>
                <div className={classes(YouTubePage.styles.video, DiscoverPage.styles.video)}>
                  <div dangerouslySetInnerHTML={{ __html: decodeURIComponent(model.section_3_video) }} />
                </div>
              </div>
              <div className={PageAbout.styles.section}>
                <div className={classes(YouTubePage.styles.video, DiscoverPage.styles.video)}>
                  <div dangerouslySetInnerHTML={{ __html: decodeURIComponent(model.section_4_video) }} />
                </div>
                <div>
                  <h3><TextNoOrphan value={model.section_4_title}/></h3>
                  <p>{model.section_4_content}</p>
                </div>
              </div>
            </div>
            <div className={PageAbout.styles.team}>
              <h2><TextNoOrphan value={model.testimonials_title}/></h2>
              <p>{model.testimonials_strap}</p>
              <div>
                {model.testimonials.map((testimonial, index) => (
                  <div key={index.toString()} className={classes(PageAbout.styles.member, YouTubePage.styles.testimonial)}>
                    <div className={DiscoverPage.styles.video}>
                      <div dangerouslySetInnerHTML={{ __html: decodeURIComponent(testimonial.video) }} />
                    </div>
                    <div>
                      <h5>
                        <a href={`https://www.youtube.com/user/${testimonial.channel_id}`} target="_blank">
                           {testimonial.channel_name}
                        </a>
                      </h5>
                      <p>{testimonial.quote}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <PageHomeCTASeparator className={PageAbout.styles.ctaSeparator}/>
            <div className={PageAbout.styles.cta}>
              <h3>{model.cta_title}</h3>
              <p>{model.cta_content}</p>
              {onSignUp && (
                <ButtonPill onClick={onSignUp} primary={true}>
                  {model.cta_button}
                </ButtonPill>
              )}
            </div>
          </div>
        )}
      </MainWrapper>
    )
  }

  handleSignUp = () => {
    this.props.controller.onboarding.openSignUpModal('/youtube');
  }

  static styles = {
    video: style({
      width: percent(100)
    }),
    testimonial: style(
      {
        $nest: {
          '& > div:first-child': {
            width: important('100%'),
            maxWidth: important('none'),
            height: important('auto'),
            maxHeight: important('none'),
            flex: 2,
          },
          '& > div:last-child': {
            textAlign: 'center',
            padding: '0 10px',
            flex: 1,
          }
        }
      }
    )
  }
}